// import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBehance, faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';





const Footer = () => {
  return (
    <div id='WebsiteFooter'> 
    
    <div> © 2026 — Designed and developed by yours truly. <br /> 
          Contact me at <a className="mailTo" href="mailto:hello@sathya.design">hello@sathya.design</a> 
    </div>


        <div id="mainbox">
              <a className="SocialIcons" href="https://www.linkedin.com/in/sathya-krishnamurthy" target='blank'>
                <FontAwesomeIcon icon ={faLinkedinIn} size="2x"/>
              </a>

              <a className="SocialIcons" href="https://github.com/sathya716" target="blank" > 
                <FontAwesomeIcon icon ={faGithub} size="2x"/>
              </a>

              <a className="SocialIcons" href="https://www.behance.net/sathyakrishnamurthy" target="blank">
                <FontAwesomeIcon icon={faBehance} size="2x" />
              </a>

        </div>
      
    </div>

  )
}

export default Footer